module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('loader', {
    attrs: {
      "loading": _vm.loading
    }
  }), _vm._v(" "), (!_vm.loading) ? _c('div', [(!_vm.loading) ? _c('header', {
    staticClass: "c-toolbar"
  }, [_c('div', {
    staticClass: "l-level"
  }, [_c('div', {
    staticClass: "l-level__left"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": _vm.module.logo,
      "alt": ""
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "c-toolbar__title title"
  }, [_vm._v("Editar produto")])])])]) : _vm._e(), _vm._v(" "), (_vm.product) ? _c('div', [_c(_vm.productProvideEdit, {
    ref: "productProvideEditProduct",
    tag: "component",
    attrs: {
      "product": _vm.product
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('panel', [_c('button', {
    staticClass: "btn btn--success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.$t('save.label')))])])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34d0e02f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/ProductProvide/Edit.vue
// module id = 3044
// module chunks = 0